"use client";
import "./not-found.css";
import Image from "next/image";
import { Button } from "antd";
import { _eventBus } from "../core/events/EventBus";
import { useRecState } from "../Orchestrator/Recoils/Events/Recoil";
import { useIntl } from "react-intl";

export default function NotFound() {
  const [isAuthenticated] = useRecState<boolean>("isAuthenticatedStateAtom");
  const intl = useIntl();
  return (
    <div className="not-found-main">
      <div className="not-found-card">
        <div className="not-found-img">
          <Image
            src="/images/not-found.svg"
            width={409}
            height={205}
            alt="not_found"
          />
        </div>
        <h1 className="main-heading">{intl.formatMessage({ id: "pageNotFound" })}</h1>
        <div className="page-content">
          <p>{intl.formatMessage({ id: "requestNotFound" })} <br />{intl.formatMessage({ id: "goBackToHome" })}</p>
        </div>
        <div className="back-action-btn">
          <Button
            type="primary"
            className="back-btn"
            onClick={() => {
              if (isAuthenticated) {
                _eventBus.emit({
                  eventName: "ROUTE_CHANGE",
                  data: "/search",
                });
              } else {
                _eventBus.emit({
                  eventName: "ROUTE_CHANGE",
                  data: "/",
                });
              }
            }}
          >
            {intl.formatMessage({ id: "backToHome" })}
          </Button>
        </div>
      </div>
    </div>
  );
} 